import VehicleRegister from './VehicleRegister';

export default VehicleRegister;
